<template>
    <md-field>
        <slot></slot>
        <md-input
                :value="value"
                type="text"
                @change="updateValue($event)"
        ></md-input>
        <input
               :value="value"
               @change="updateValue($event)"
               type="color">
    </md-field>
</template>

<script>
    export default {
        name: "color-picker",
        props: {
            value: String
        },
        methods: {
            updateValue(event){
                this.$emit('input',event.target.value)
            }
        }
    }
</script>

<style scoped>

</style>